export const LINKS = {
  MODAK_MAKERS_LEGAL: 'https://www.modakmakers.com/legal',
  MODAK_SUPPORT: 'https://www.modakmakers.com/support',
  MODAK_FAQ_SUPPORT:
    'https://www.modakmakers.com/faq/where-can-i-find-customer-support',
  PROMOS: 'https://www.modakmakers.com/promos',
  MODAK_MOBILE_STORE: 'https://modak.go.link/eJr1m',
  MODAK_DOWNLOAD_PARENT_APP: 'https://modak.go.link/?adj_t=1311mi7i_13qgp2xr',
  PRIVACY_POLICY: 'https://www.modakmakers.com/legal/privacy',
  E_SIGNATURE_AGREEMENT: 'https://www.modakmakers.com/legal/eca',
  CONSUMER_ACCOUNT_CARD_HOLDER_AGREEMENT:
    'https://www.modakmakers.com/legal/lcb-agreement',
  ARTICLE_NERDWALLET:
    'https://www.nerdwallet.com/article/banking/buzzy-banking-apps-for-kids-and-teens',
  MODAK_GET_STARTED: (
    utmSource: string,
    utmMedium: string,
    utmCampaign: string,
    utmContent: string,
    referralCode: string,
  ) =>
    `https://www.modakmakers.com/?utm_source=${utmSource}&utm_medium=${utmMedium}&utm_campaign=${utmCampaign}&utm_content=${utmContent}&referral_code=${referralCode}`,
  MODAK_PAYMENT_LINK_GET_STARTED: (
    utmMedium: string,
    utmCampaign: string,
    referralCode: string,
  ) =>
    `https://www.modakmakers.com/?utm_source=PaymentLink&utm_medium=${utmMedium}&utm_campaign=${utmCampaign}&utm_content=Get_Started&referral_code=${referralCode}`,
  MODAK_REQUEST_MONEY:
    'https://www.modakmakers.com/?utm_source=PaymentLink&utm_medium=web&utm_campaign=Act_RequestMoney&utm_content=OneTimeRequest',
  REQUEST_MONEY_TERMS:
    'https://www.modakmakers.com/legal/modak-request-money-terms-and-conditions',
  CHARGE_BACK_DISPUTE_POLICY:
    'https://www.modakmakers.com/legal/chargeback-and-dispute-policy',
  WAIT_LIST: 'https://www.modakmakers.com/waitlist',
  FEATURES_COMING_SOON:
    'https://www.modakmakers.com/information-on-features-coming-soon',
  REFERRAL_PROGRAM:
    'https://www.modakmakers.com/promos/terms-conditions-for-the-referral-program',
  TERMS_AND_CONDITIONS: 'https://www.modakmakers.com/legal/terms',
  MODAK_MAKER_USA_PATRIOT_URL:
    'https://www.modakmakers.com/legal/usa-patriot-act-notice',
} as const;
